import useTranslation from '../../localization/i18n.context';
import InfoFeedbackScreen from '../../components/shared/InfoFeedbackScreen/InfoFeedbackScreen';
import InfoTriangle from '../../assets/images/info-triangle.webp';
import { useEffect, useRef } from 'preact/hooks';
import { CloseWebviewEvent } from '../../sdk/close.webview.event';
import useAndroidBackPress from '../../hooks/back.listener.hook';
import { TrackingEvent } from '../../sdk/tracking.event';

const FLOWS_EVENTS = {
  pickup: TrackingEvent.Events.PICKUP_ERROR_SHOW,
};

export default function TryAgainPage({ step, flow }) {
  const { t } = useTranslation();
  const closeRef = useRef(null);

  useAndroidBackPress(closeRef.current, () => {
    closeRef.current.props.onClick();
  });

  useEffect(() => {
    if (step && flow) {
      TrackingEvent.trigger(FLOWS_EVENTS[flow], TrackingEvent.Sources.CAAS, {
        step,
      });
    }
  }, []);

  return (
    <InfoFeedbackScreen
      onCloseClick={() => CloseWebviewEvent.closedByUser()}
      closeRef={closeRef}
      image={InfoTriangle}
      title={t('Ooops!')}
      subtitle={t('Something went wrong')}
      ctaAction={() => history.back()}
      ctaText={t('Try Again')}
    />
  );
}
